import React, { useState } from "react";
import back from "../assets/images/back_arrow.png";
import { useNavigate } from "react-router-dom";
import $ from "jquery";
import { useEffect } from "react";
import Axios from "axios";
import { message } from "antd";
import Header from "../components/Header";
import "../css/Header.css";
const ContactUs = () => {
  let phoneno = localStorage.getItem("phoneNo");
  const [name, setName] = useState("");
  const [email, setEmail] = useState("");
  const [buttonHide, setButtonHide] = useState(false);
  const [messageState, setMessageState] = useState("");
  const [errMsg, setErrMsg] = useState("");
  const [msg, setMsg] = useState("");
  const [patientDetails, setPatientDetails] = useState([]);
  const onEmailUpdate = (e) => {
    setEmail(e.target.value);
  };
  const onMessageUpdate = (e) => {
    setMessageState(e.target.value);
  };
  const navigate = useNavigate();
  const backHandler = () => {
    global.OTPValidation = "true";
    navigate("/Tickets");
  };

  useEffect(() => {
    const fetchPatientDetails = async () => {
      const token = localStorage.getItem("token");
      const headers = {
        Authorization: `Bearer ${token}`, // Add the token to the request headers
      };

      try {
        const response = await Axios.get(
          `${process.env.REACT_APP_GLOBAL_BASEURL}/api/patientapi/PatientBioProfile/alldetails?phone=${phoneno}&MDT=PM&user_role=rp`,
          { headers }
        );

        console.log("patient's all data", response.data);

        if (response.data.status == '1') {
          setPatientDetails(response.data.data);
          setName(response.data.data[0]?.first_name || "");
        } else if (response.data.status == '401') {
          console.error("Unauthorized access. Logging out.");
          message.error("Unauthorized access. Logging out.");
          logoutHandler();
        } else if (response.data.status == '0') {
          message.error("An error occurred. Please try again.");
        }
      } catch (error) {
        if (error.response && error.response.status == '401') {
          console.error("Unauthorized access. Logging out.");
          message.error(error.response.data?.message || "Unauthorized");
          logoutHandler();
        } else {
          console.error("Error:", error.message);
          message.error("An error occurred. Please try again.");
        }
      }
    };

    fetchPatientDetails();
  }, [phoneno]); // Add dependencies if needed

  const logoutHandler = () => {
    localStorage.removeItem("phoneNo");
    localStorage.removeItem("patientid");
    localStorage.removeItem("patientLocalImage");
    localStorage.removeItem("patientLocalData");
    localStorage.removeItem("patientUniqueId");
    localStorage.removeItem("chronic_illness_data");
    localStorage.removeItem("allergic_information_data");
    localStorage.removeItem("family_relation_data");
    localStorage.removeItem("family_disease_data");
    localStorage.removeItem("token");

    navigate("/Login");
  };

  const postHandler = (e) => {
    const token = localStorage.getItem("token");
    const headers = {
      Authorization: `Bearer ${token}`,
    };
    setButtonHide(true);
    e.preventDefault();
    console.log(
      "email: ",
      email,
      "messageState: ",
      messageState,
      "name: ",
      name
    );
    setErrMsg("");

    if (email != "" && messageState != "" && name != "") {
      let formdata = $(e.target);
      formdata = new FormData();
      formdata.append("name", name);
      formdata.append("email", email);
      formdata.append("phone_no", phoneno);
      formdata.append("message", messageState);
      formdata.append("MDT", "PM");
      formdata.append("user_role", "rp");
      $.ajax({
        type: "POST",
        url: `${process.env.REACT_APP_GLOBAL_BASEURL}/api/patientapi/PatientsSupport/create_ticket`,
        data: formdata,
        processData: false,
        contentType: false,
        headers: headers,
        success(data) {
          console.log("post successfully", data);
          setMsg("Message send successfully");
          setTimeout(navigate("/Tickets"), 2000);
          setButtonHide(false);
        },
        error: function (err) {
          if (err.status == '401') {
            // Token expired, show message and log out
            message.error(err.responseJSON.message);
            logoutHandler();
          } else {
            console.error("Error occurred:", err.responseText);
            alert(`Error has occurred: ${err.responseText}`);
          }
          setButtonHide(false);
        },
      });
    } else {
      setButtonHide(false);
      e.preventDefault();
      setErrMsg("All fields are required");
    }
  };

  return (

    <div className="background-container">
      <header className="header">
        <img src={back} style={{ height: 20, width: 20 }} alt="back button" onClick={backHandler} />
        <h1 className="header-title">New support ticket</h1>
      </header>
      <div className="login" >
        <div class="fs-6 fw-light mb-2">
          Post your messageState below. We will get back to you ASAP via phone
          or email
        </div>
        <div style={{ textAlign: "center", marginTop: 20 }}>
          {/* <p style={{ textAlign: 'left', fontSize: 14, fontWeight: 'bold' }}>Name *</p>
          <input type="text" name="Name" required placeholder="name "
            value={name}
            onChange={(event) => onNameUpdate(event)}
          /> */}
          <p style={{ textAlign: "left", fontSize: 14, fontWeight: "bold" }}>
            Email *
          </p>
          <input
            type="email"
            name="email"
            required
            placeholder="email "
            value={email}
            maxLength={30}
            onChange={(event) => onEmailUpdate(event)}
            style={{fontSize: '12px'}}
          />
          {/* <p style={{ textAlign: 'left', fontSize: 14, fontWeight: 'bold' }}>Phone *</p>
          <input type="tel" name="phone" required placeholder="enter your login phone no"
            value={phone}
            onChange={(event) => onPhoneUpdate(event)}
          /> */}
          <p style={{ textAlign: "left", fontSize: 14, fontWeight: "bold" }}>
            Message *
          </p>
          <textarea
            class="form-control"
            id="messageState"
            name="messageState"
            rows="5"
            value={messageState}
            onChange={(event) => onMessageUpdate(event)}
            style={{fontSize: '12px'}}
          ></textarea>
        </div>

        {msg ? (
          <p
            style={{
              fontSize: 16,
              fontWeight: "bold",
              color: "red",
              marginTop: 10,
            }}
          >
            {msg}
          </p>
        ) : null}
        {errMsg ? (
          <p
            style={{
              fontSize: 16,
              fontWeight: "bold",
              color: "red",
              marginTop: 10,
            }}
          >
            {errMsg}
          </p>
        ) : null}
        <form method="post" onSubmit={(event) => postHandler(event)}>
          {buttonHide == false ? (
            <button
              type="submit"
              style={{ marginTop: 30, width: 320, fontSize: '16px' }}
              className="btn btn-auto btn-primary"
            >
              Post
            </button>
          ) : (
            <p
              style={{
                fontSize: 16,
                color: "green",
                fontWeight: "bold",
                marginTop: 15,
                marginLeft: 50,
              }}
            >
              Sending...
            </p>
          )}
        </form>
      </div>
    </div>

  );
};

export default ContactUs;
